import type { NotificationData } from "@mantine/notifications";
import { NotificationPresets } from "../mantinePresets";
import { defaultNotificationOptions } from "./notifications.constants";

interface GetAdjustedNotificationOptionsParams {
  extractedMessage: NotificationData["message"];
  isUpdate?: boolean;
  type?: keyof typeof NotificationPresets;
}

/* This file should be removed once we stepped up our toast game and don't use big messages in toasts anymore. */
function getAdjustedNotificationOptions({
  extractedMessage,
  isUpdate = false,
  type
}: GetAdjustedNotificationOptionsParams) {
  const isBigMessage =
    typeof extractedMessage === "string" && extractedMessage.length > 140;
  const adjustedNotificationOptions: Partial<NotificationData> = {
    ...defaultNotificationOptions
  };
  if (!isUpdate && type) {
    adjustedNotificationOptions.color = NotificationPresets[type]?.color;
    adjustedNotificationOptions.icon = NotificationPresets[type]?.icon;
    adjustedNotificationOptions.autoClose =
      NotificationPresets[type]?.autoClose;
  }
  if (isBigMessage) {
    adjustedNotificationOptions.autoClose = false;
    adjustedNotificationOptions.withCloseButton = true;
  }
  return adjustedNotificationOptions;
}

export { getAdjustedNotificationOptions };
